import { convertNumber } from '@/utils/'
import moment from 'moment'
import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
  const itemTypes = {
    1: '单品SKU',
    2: 'SPU',
    3: '套餐',
  }
  const orderTypes = {
    1: '支付订单',
    2: '退款订单',
  }

  const orderSource = {
    1: 'B端商城',
    2: 'C端商城',
    3: '车队定制',
  }
  const orderStates = {
    1: '已结算',
  }
  const searchBoxColumns = [
    {
      type: 'input',
      label: '订单号',
      key: 'orderId',
      options: {
        clearable: true,
      },
    },
    {
      type: 'select',
      label: '订单类型',
      key: 'orderType',
      source: [{ label: '支付订单', value: 1 }, { label: '退款订单', value: 2 }],
      options: {
        clearable: true,
      },
    },
    {
      type: 'input',
      label: '流水号',
      key: 'serialNumber',
      options: {
        clearable: true,
      },
    },
    {
      type: 'datePick',
      label: `${this.activeName === '0' ? '支付时间' : '订单完成时间'}`,
      key: 'chargeEndTime',
      options: {
        clearable: !this.$route.query.billCycle,
        'value-format': 'timestamp',
        pickerOptions: {
          disabledDate: (time) => {
            const { billCycle } = this.$route.query
            const startDate = new Date(moment(billCycle).startOf('month')).getTime() - (1000 * 60 * 60 * 24)
            const endDate = new Date(moment(billCycle).endOf('month')).getTime()
            const state = (time.getTime() <= startDate) || (time.getTime() >= endDate)
            return state
          },
        },
      },
    },
  ]

  const comSearchBoxColumns = [
    {
      type: 'input',
      label: '账单ID',
      key: 'billId',
      options: {
        clearable: true,
      },
    },
  ]


  const orderTableColumns = [
    {
      name: 'companyName', // 和产品沟通后，这里公司名称保留
      align: 'center',
      columnProps: {
        label: '公司名称',
        prop: 'companyName',
        minWidth: 120,
      },
    },
    {
      name: 'parentOrderId',
      align: 'center',
      columnProps: {
        label: '订单号',
        prop: 'parentOrderId',
        minWidth: 120,
      },
    },
    {
      name: 'orderId',
      align: 'center',
      columnProps: {
        label: '子订单ID',
        prop: 'orderId',
        minWidth: 120,
      },
    },
    {
      name: 'businessOrderId',
      align: 'center',
      columnProps: {
        label: '商家订单号',
        prop: 'businessOrderId',
        minWidth: 120,
      },
    },
    {
      name: 'itemType',
      align: 'center',
      columnProps: {
        label: '类型',
        prop: 'itemType',
        minWidth: 120,
      },
      getText: ({ row }) => itemTypes[row.itemType],
    },
    {
      name: 'orderSource',
      align: 'center',
      columnProps: {
        label: '订单来源',
        prop: 'orderSource',
        minWidth: 120,
      },
      getText: ({ row }) => orderSource[row.orderSource],
    },
    {
      name: 'middlePayId',
      align: 'center',
      columnProps: {
        label: '支付流水号',
        prop: 'middlePayId',
        minWidth: 120,
      },
    },
    {
      name: 'tenantId',
      align: 'center',
      columnProps: {
        label: '维保服务商ID',
        prop: 'tenantId',
        minWidth: 120,
      },
    },
    {
      name: 'tenantName',
      align: 'center',
      columnProps: {
        label: '维保服务商名称',
        prop: 'tenantName',
        minWidth: 120,
      },
    },
    {
      name: 'businessId',
      align: 'center',
      columnProps: {
        label: '门店ID',
        prop: 'businessId',
        minWidth: 120,
      },
    },
    {
      name: 'businessName',
      align: 'center',
      columnProps: {
        label: '门店名称',
        prop: 'businessName',
        minWidth: 120,
      },
    },
    {
      name: 'createTime',
      align: 'center',
      columnProps: {
        label: '下单时间',
        prop: 'createTime',
        minWidth: 120,
      },
    },
    {
      name: 'tradeTime',
      align: 'center',
      columnProps: {
        label: '支付/退款完成时间',
        prop: 'tradeTime',
        minWidth: 120,
      },
    },
    {
      name: 'orderType',
      align: 'center',
      columnProps: {
        label: '订单类型',
        prop: 'orderType',
        minWidth: 120,
      },
      getText: ({ row }) => orderTypes[row.orderType],
    },
    {
      name: 'orderState',
      align: 'center',
      columnProps: {
        label: '订单状态',
        prop: 'orderState',
        minWidth: 120,
      },
      getText: ({ row }) => orderStates[row.orderState],
    },
    {
      name: 'orderAmount',
      align: 'center',
      columnProps: {
        label: '订单金额',
        prop: 'orderAmount',
        minWidth: 120,
      },
      getText: ({ row }) => `${convertNumber(row.orderAmount)}元`,
    },
    {
      name: 'orderFactAmount',
      align: 'center',
      columnProps: {
        label: '订单实付金额',
        prop: 'orderFactAmount',
        minWidth: 120,
      },
      getText: ({ row }) => `${convertNumber(row.orderFactAmount)}元`,
    },
    {
      name: 'discountAmount',
      align: 'center',
      columnProps: {
        label: '总优惠金额',
        prop: 'discountAmount',
        minWidth: 120,
      },
      getText: ({ row }) => `${convertNumber(row.discountAmount)}元`,
    },
  ]

  const writeoffTableColumns = [
    {
      name: 'companyName', // 和产品沟通后，这里公司名称保留
      align: 'center',
      columnProps: {
        label: '公司名称',
        prop: 'companyName',
        minWidth: 120,
      },
    },
    {
      name: 'parentOrderId',
      align: 'center',
      columnProps: {
        label: '订单号',
        prop: 'parentOrderId',
        minWidth: 120,
      },
    },
    {
      name: 'orderId',
      align: 'center',
      columnProps: {
        label: '子单ID',
        prop: 'orderId',
        minWidth: 120,
      },
    },
    {
      name: 'businessOrderId',
      align: 'center',
      columnProps: {
        label: '商家订单号',
        prop: 'businessOrderId',
        minWidth: 120,
      },
    },
    {
      name: 'orderSource',
      align: 'center',
      columnProps: {
        label: '订单来源',
        prop: 'orderSource',
        minWidth: 120,
      },
      getText: ({ row }) => orderSource[row.orderSource],
    },
    {
      name: 'safetyUserNumber',
      align: 'center',
      columnProps: {
        label: '脱敏手机号',
        prop: 'safetyUserNumber',
        minWidth: 120,
      },
    },
    {
      name: 'carPlateNo',
      align: 'center',
      columnProps: {
        label: '车牌号后4位',
        prop: 'carPlateNo',
        minWidth: 120,
      },
    },
    {
      name: 'businessId',
      align: 'center',
      columnProps: {
        label: '门店ID',
        prop: 'businessId',
        minWidth: 120,
      },
      getText: ({ row }) => `${row.businessName}(${row.businessId})`,
    },
    {
      name: 'provinceName',
      align: 'center',
      columnProps: {
        label: '门店所属省',
        prop: 'provinceName',
        minWidth: 120,
      },
    },
    {
      name: 'itemType',
      align: 'center',
      columnProps: {
        label: '类型',
        prop: 'itemType',
        minWidth: 120,
      },
      getText: ({ row }) => itemTypes[row.itemType],
    },
    {
      name: 'skuId',
      align: 'center',
      columnProps: {
        label: '商品SKU ID',
        prop: 'skuId',
        minWidth: 120,
      },
    },
    {
      name: 'skuName',
      align: 'center',
      columnProps: {
        label: '关联SKU名称',
        prop: 'skuName',
        minWidth: 120,
      },
    },
    {
      name: 'originPrice',
      align: 'center',
      columnProps: {
        label: '单价',
        prop: 'originPrice',
        minWidth: 120,
      },
      getText: ({ row }) => `${convertNumber(row.originPrice)}`,
    },
    {
      name: 'price',
      align: 'center',
      columnProps: {
        label: '平台价',
        prop: 'price',
        minWidth: 120,
      },
      getText: ({ row }) => `${convertNumber(row.price)}`,
    },
    {
      name: 'num',
      align: 'center',
      columnProps: {
        label: '数量',
        prop: 'num',
        minWidth: 120,
      },
    },
    {
      name: 'originAmount',
      align: 'center',
      columnProps: {
        label: '商品总金额',
        prop: 'originAmount',
        minWidth: 120,
      },
      getText: ({ row }) => `${convertNumber(row.originAmount)}`,
    },
    {
      name: 'amount',
      align: 'center',
      columnProps: {
        label: '商品履约金额',
        prop: 'amount',
        minWidth: 120,
      },
      getText: ({ row }) => `${convertNumber(row.amount)}`,
    },
    {
      name: 'middlePayId',
      align: 'center',
      columnProps: {
        label: '支付流水号',
        prop: 'middlePayId',
        minWidth: 120,
      },
    },
    {
      name: 'createTime',
      align: 'center',
      columnProps: {
        label: '下单时间',
        prop: 'createTime',
        minWidth: 120,
      },
    },
    {
      name: 'finishTime',
      align: 'center',
      columnProps: {
        label: '订单完成时间',
        prop: 'finishTime',
        minWidth: 120,
      },
    },
  ]

  // 和产品沟通后，这里公司id和名称保留
  const comTableColumns = [
    {
      name: 'companyId',
      align: 'center',
      columnProps: {
        label: '公司ID',
        prop: 'companyId',
        minWidth: 120,
      },
    },
    {
      name: 'companyName',
      align: 'center',
      columnProps: {
        label: '公司名称',
        prop: 'companyName',
        minWidth: 120,
      },
    },
    {
      name: 'billCycle',
      align: 'center',
      columnProps: {
        label: '账单周期',
        prop: 'billCycle',
        minWidth: 120,
      },
    },
    {
      name: 'billId',
      align: 'center',
      columnProps: {
        label: '账单ID',
        prop: 'billId',
        minWidth: 120,
      },
    },
    {
      name: 'orderNum',
      align: 'center',
      columnProps: {
        label: '本期订单数',
        prop: 'orderNum',
        minWidth: 120,
      },
    },
    {
      name: 'totalAmount',
      align: 'center',
      columnProps: {
        label: '本期交易订单总额',
        prop: 'totalAmount',
        minWidth: 120,
      },
      getText: ({ row }) => `${convertNumber(row.totalAmount)}`,
    },
    {
      name: 'offsetAmount',
      align: 'center',
      columnProps: {
        label: '本期交易订单用户实付总额',
        prop: 'offsetAmount',
        minWidth: 120,
      },
      getText: ({ row }) => `${convertNumber(row.offsetAmount)}`,
    },
  ]

  this.$nextTick(() => {
    comTableColumns.push(
      {
        name: 'operate',
        align: 'center',
        columnProps: {
          label: '操作',
          width: 240,
          fixed: 'right',
        },
        maxShowLength: operateMaxShowLength,
        render: ({ row }) => {
          const btns = []

          btns.push(
            this.$createElement('el-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.openBillDetail(row)
                },
              },
            }, '账单明细'),
          )

          return btns
        },
      },
    )
  })

  return {
    searchBoxColumns,
    orderTableColumns,
    writeoffTableColumns,
    comSearchBoxColumns,
    comTableColumns,
  }
}
